import React, {useState, useEffect} from 'react';
import axios from 'axios';
import config from '../../config/apiConfig';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
//alertas
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//loading
import BeatLoader from "react-spinners/BeatLoader";
import { css } from "@emotion/react";

//Modal
import Modal from 'react-modal';
//Utilidades
import FormatoMoneda from '../Utiles';
//confirmación
import { confirmAlert } from 'react-confirm-alert'; // Import
//grafico
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from 'recharts';

import { registerLocale, setDefaultLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
registerLocale('es', es)


function ReporteProductosRentabilidad() {
//loading   
const [loading, setLoading] = useState(false);

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

//hooks
const [fechaInicio, setFechaInicio] = useState( new Date());
const [fechaTermino, setFechaTermino] = useState( new Date());
const [productos, setProductos] = useState([]);
const [mensajeError, setMensajeError] = useState('');
const [cantidad, setCantidad] = useState(10);

const [data, setData] = useState([]);
const [colors, setColors] = useState();
  
//const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const RADIAN = Math.PI / 180;



useEffect(()=>{
    const token = localStorage.getItem("token");
    axios.defaults.headers.common["token"] = token;
    //getCategorias();  
},[]);


function ColorCode() {
    var makingColorCode = '0123456789ABCDEF';
    var finalCode = '#';
    for (var counter = 0; counter < 6; counter++) {
       finalCode =finalCode+ makingColorCode[Math.floor(Math.random() * 16)];
    }
    
    return finalCode;
}

async function buscar(){
    
    // llamada a la api
    setLoading(true);
    await axios.get(config.api_url+"/reportes/productos/rentabilidad/?cantidad="+ cantidad).then(resp=>{
        if (resp.data.completado){
             console.log(resp.data)
             
             let datos =[];
             let color =[];
             let productos_ =[];
             resp.data.productos.forEach(producto => {  
                    let color_ =ColorCode();
                    // Datos para el gráfico
                    color.push( color_)
                  //  datos.push({'name': producto.nombre , 'value': parseInt(producto.porcentaje)})
                    productos_.push({'nombre':producto.nombre, 'porcentaje': producto.porcentaje, 'color': color_, "costo":producto.costo, "valor": producto.valor, "iva": producto.valorIva})
                   
             });
             console.log(datos);
             setColors(color);
             //setData(datos)
             setProductos(productos_);
             setLoading(false);
        }else{
            toast.error(resp.data.mensaje);
            setLoading(false);
        }
     }).catch(error=>{
        console.log(error)
        setLoading(false);
        toast.error("Se ha provocado un error al ejecutar la busqueda!");
    })
}

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
      <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
};

const SeleccionaItem = (producto)=>{
    let data_ = [...data];
    data_.push({'name': producto.nombre , 'value': parseInt(producto.porcentaje)});
    setData(data_);
}


return (
    <div className="contenedorMantenedor">
        <ToastContainer/>
        <div className='card'>
            <div className='card-header'>
                <div className='row'>
                    <div className="col-md-12">
                        <div className="d-flex justify-content-start">
                            <a href='/reportes/home/'><i class="bi bi-arrow-left-short"></i> Reportes </a>   
                        </div>
                         <h2> <i className="bi bi-cash-stack"></i> Reporte Rentabilidad de Productos</h2>
                    </div>
                </div>
            </div>
            <div className='card-body'>
                <div className="row">      
                   <div className="col-12 col-md-2">
                        <button type="button" class="btn btn-secondary" onClick={buscar}><i className="bi bi-search"></i>Consultar</button>
                    </div>
                </div>
                <br/>
                <div className="row">
                    <div className="col-md-12" style={{paddingLeft:"5%", paddingRight:"5%"}}>
                        <div className="alert alert-warning"  hidden={mensajeError? false:true} role="alert">
                            {mensajeError}
                        </div>
                    </div>
                </div>
                <div className="row" style={{width:"90%", marginLeft:"5%", marginRight:"5%"}}>
                    <div className="col-md-6" >
                        {productos.length>0?
                            <div className='table-responsive-sm'>
                                <table className="table table-striped">
                                    <thead class="thead-dark">
                                        <tr>
                                        <th scope="col"></th>    
                                        <th scope="col"></th>    
                                        <th scope="col">Producto</th>
                                        <th scope="col">Porcentaje</th>
                                        <th scope="col">costo</th>
                                        <th scope="col">valor</th>  
                                        <th scope="col">IVA</th>
                                        </tr>
                                    </thead>
                                    <tbody>   
                                        {productos.map(item =>  
                                            <tr key={item.id} > 
                                                <td>
                                                    <i className="bi bi-bookmark-fill" style={{color:item.color}}></i>    
                                                </td>
                                                <td>
                                                    <div className="form-group form-check">
                                                        <input type="checkbox" onChange={(ev)=>SeleccionaItem(item)} className="form-check-input" id="exampleCheck1"/>
                                                    </div>
                                                </td>
                                                <td>{item.nombre}</td>
                                                <td>
                                                    {item.porcentaje}%
                                                </td>
                                                <td>
                                                    ${FormatoMoneda(item.costo)}
                                                </td>
                                                <td>
                                                    ${FormatoMoneda(item.valor)}
                                                </td>
                                                <td>
                                                    ${item.iva}
                                                </td>
                                            </tr>)
                                        }
                                    </tbody>
                            </table>
                            </div>
                            :''}
                    </div>
                  {/*COlumna gráfico */}
                    <div className='col-md-6'>
                                      <ResponsiveContainer width={"100%"} height={500}>
                                          <PieChart width={400} height={600}>
                                              <Pie
                                                  data={data}
                                                  cx="50%"
                                                  cy="50%"
                                                  labelLine={false}
                                                  label={renderCustomizedLabel}
                                                  outerRadius={150}
                                                  fill="#8884d8"
                                                  dataKey="value">
                                                  {data.map((entry, index) => (
                                                  <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                                                  ))}
                                              </Pie>
                                          </PieChart>
                                      </ResponsiveContainer>
                                  </div>
                </div>
            </div>
        </div>
      
        <br/>
        <BeatLoader color={config.color_loader} loading={loading} css={override} size={50} />
        <br/>
       
   
    </div>
)

}
export default ReporteProductosRentabilidad;